import { queryMyLatestShopApply, queryMyShop } from '@/api/mall'
import { SHOP_AUDIT_STATE } from '@/enum'

const getDefaultState = () => ({
	shopInfo: {},
	latestApply: {},
	// 是否已经完成过一次店铺及申请信息查询，用于复用查询结果，避免每次路由切换都重复请求接口。
	loaded: false,
	// 当前是否正在查询店铺及申请信息，用于阻止同一时间内发起重复请求，也可供页面展示加载状态。
	loading: false
})

const state = getDefaultState()

const mutations = {
	SET_SHOP_INFO(state, shopInfo) {
		state.shopInfo = shopInfo || {}
	},
	SET_LATEST_APPLY(state, latestApply) {
		state.latestApply = latestApply || {}
	},
	SET_LOADED(state, loaded) {
		state.loaded = loaded
	},
	SET_LOADING(state, loading) {
		state.loading = loading
	},
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	}
}

const actions = {
	/**
	 * 同时查询店铺和最新申请，菜单与路由守卫必须共用该结果。
	 * force=true 用于申请提交、审核状态变化等需要立即刷新的场景。
	 */
	async loadShopContext({ state, commit }, force = false) {
		// 已成功加载且不要求强制刷新时，直接返回状态管理中的缓存数据。
		if (state.loaded && !force) {
			return { shopInfo: state.shopInfo, latestApply: state.latestApply }
		}
		// 首次请求尚未结束时，后续非强制请求不再重复调用接口。
		if (state.loading && !force) return null

		commit('SET_LOADING', true)
		try {
			const [shopResponse, applyResponse] = await Promise.all([
				queryMyShop().catch(() => ({ data: null })),
				queryMyLatestShopApply().catch(() => ({ data: null }))
			])
			const shopInfo = shopResponse.data || {}
			const latestApply = applyResponse.data || {}
			commit('SET_SHOP_INFO', shopInfo)
			commit('SET_LATEST_APPLY', latestApply)
			commit('SET_LOADED', true)
			return { shopInfo, latestApply }
		} finally {
			commit('SET_LOADING', false)
		}
	},
	resetState({ commit }) {
		commit('RESET_STATE')
	}
}

const getters = {
	hasShop: state => Boolean(state.shopInfo && state.shopInfo.id),
	auditState: state => (state.latestApply.auditState === undefined ? null : Number(state.latestApply.auditState)),
	// 已生成店铺或开店申请审核通过，均视为已具备服务商业务菜单访问资格。
	isApproved: (state, getters) => getters.hasShop || getters.auditState === SHOP_AUDIT_STATE.PASS,
	hasApplied: state => Boolean(state.latestApply && state.latestApply.id)
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
